<template>
	<v-dialog
		v-model="visible_local"
		persistent
		:retain-focus="false"
		:fullscreen="is_fullscreen"
	>
		<ClaimContent
			:color="color"
			:claimId="claim_id"
			@close="onClose()"
		/>
	</v-dialog>
</template>

<script>
import ClaimContent from "@/views/desktop/webexpense/webexpense_claim_content.vue";

export default {
	name: 'WebExpense',
	data() {
		this.color = '#FFB946';

		return {
			visible_local: true,
			is_fullscreen: true,
			claim_id: 0,
		}
	},
	components: {
		ClaimContent
	},
	created() {
		this.claim_id = this.$route.params.evid
			? Number(this.$route.params.evid)
			: 0;
	},
	methods: {
		onClose() {
			window.open("/close")
		}
	}
}
</script>
<style lang="scss" scoped>
.title-text {
	font-family: Roboto;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	color: #192A3E;
}
.whole-context {
	background-color: #EFF1F3;
	// height: calc(100vh - 74px);
}
.inside-context {
	background-color: #FFFFFF;
	border: 1px solid rgba(25, 42, 62, 0.3);
	// height: calc(100vh - 74px - 40px);
}
.field-title-text {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #37495F;
}
</style>
